import { render } from "./crm-campaigns.vue?vue&type=template&id=591c5071&scoped=true"
import script from "./crm-campaigns.vue?vue&type=script&lang=js"
export * from "./crm-campaigns.vue?vue&type=script&lang=js"

import "./crm-campaigns.vue?vue&type=style&index=0&id=591c5071&scoped=true&lang=css"
import "./crm-campaigns.vue?vue&type=style&index=1&id=591c5071&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591c5071"]])

export default __exports__